// extracted by mini-css-extract-plugin
module.exports = {"fieldsAfterWallet":"payment-form_fieldsAfterWallet__3qpDf","row":"payment-form_row__1PgLz","input-holder":"payment-form_input-holder__3pkh6"};